module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "ds-calendar-event-popover-card",
    class: _vm.classes
  }, [_c('v-toolbar', {
    style: (_vm.styleHeader),
    attrs: {
      "extended": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', {
    attrs: {
      "slot": "extension"
    },
    slot: "extension"
  }, [_c('v-text-field', {
    attrs: {
      "single-line": "",
      "hide-details": "",
      "solo": "",
      "flat": "",
      "autofocus": "",
      "label": _vm.labels.title
    },
    model: {
      value: (_vm.details.title),
      callback: function($$v) {
        _vm.$set(_vm.details, "title", $$v)
      },
      expression: "details.title"
    }
  })], 1), _vm._v(" "), (!_vm.details.readonly) ? _c('v-btn', {
    attrs: {
      "color": "secondary",
      "small": "",
      "absolute": "",
      "bottom": "",
      "left": "",
      "fab": "",
      "icon": ""
    },
    on: {
      "click": _vm.edit
    }
  }, [_c('v-icon', [_vm._v(_vm._s(_vm.icons.edit))])], 1) : _vm._e(), _vm._v(" "), _vm._t("eventCreatePopoverToolbarLeft", null, null, _vm.slotData), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _vm._t("eventCreatePopoverToolbarRight", null, null, _vm.slotData), _vm._v(" "), _vm._t("eventCreatePopoverToolbarSave", [_c('v-btn', {
    staticClass: "ds-create-popover-save",
    style: (_vm.styleText),
    attrs: {
      "flat": "",
      "disabled": !_vm.isValid
    },
    on: {
      "click": _vm.save
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v(_vm._s(_vm.icons.save))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.labels.save))])], 1)], null, _vm.slotData), _vm._v(" "), _vm._t("eventCreatePopoverToolbarClose", [_c('v-btn', {
    style: (_vm.styleText),
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', [_vm._v(_vm._s(_vm.icons.close))])], 1)], null, _vm.slotData)], 2), _vm._v(" "), _c('v-card-text', [_vm._t("eventCreatePopoverBodyTop", null, null, _vm.slotData), _vm._v(" "), _c('v-list', [_c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("access_time")])], 1), _vm._v(" "), _c('v-list-tile-content', [_vm._t("eventCreatePopoverOccurs", [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.startDate))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(_vm.occurs))])], null, _vm.slotData)], 2)], 1), _vm._v(" "), (_vm.prompts.location && _vm.$dayspan.supports.location) ? _c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("location_on")])], 1), _vm._v(" "), _c('v-list-tile-content', [_vm._t("eventCreatePopoverLocation", [_c('v-text-field', {
    attrs: {
      "single-line": "",
      "hide-details": "",
      "solo": "",
      "flat": "",
      "full-width": "",
      "label": _vm.labels.location
    },
    model: {
      value: (_vm.details.location),
      callback: function($$v) {
        _vm.$set(_vm.details, "location", $$v)
      },
      expression: "details.location"
    }
  })], null, _vm.slotData)], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.prompts.description && _vm.$dayspan.supports.description) ? _c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("subject")])], 1), _vm._v(" "), _c('v-list-tile-content', [_vm._t("eventCreatePopoverDescription", [_c('v-textarea', {
    attrs: {
      "hide-details": "",
      "single-line": "",
      "solo": "",
      "flat": "",
      "full-width": "",
      "label": _vm.labels.description
    },
    model: {
      value: (_vm.details.description),
      callback: function($$v) {
        _vm.$set(_vm.details, "description", $$v)
      },
      expression: "details.description"
    }
  })], null, _vm.slotData)], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.prompts.calendar && _vm.$dayspan.supports.calendar) ? _c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("event")])], 1), _vm._v(" "), _c('v-list-tile-content', [_vm._t("eventCreatePopoverCalendar", [_c('v-text-field', {
    attrs: {
      "single-line": "",
      "hide-details": "",
      "solo": "",
      "flat": "",
      "full-width": "",
      "label": _vm.labels.calendar
    },
    model: {
      value: (_vm.details.calendar),
      callback: function($$v) {
        _vm.$set(_vm.details, "calendar", $$v)
      },
      expression: "details.calendar"
    }
  })], null, _vm.slotData)], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.prompts.color && _vm.$dayspan.supports.color) ? _c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("invert_colors")])], 1), _vm._v(" "), _c('v-list-tile-content', [_vm._t("eventCreatePopoverColor", [_c('v-select', {
    attrs: {
      "single-line": "",
      "hide-details": "",
      "solo": "",
      "flat": "",
      "full-width": "",
      "items": _vm.$dayspan.colors,
      "color": _vm.details.color
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-list-tile-content', [_c('div', {
          staticClass: "ds-color-option",
          style: ({
            backgroundColor: item.value
          }),
          domProps: {
            "textContent": _vm._s(item.text)
          }
        })])]
      }
    }]),
    model: {
      value: (_vm.details.color),
      callback: function($$v) {
        _vm.$set(_vm.details, "color", $$v)
      },
      expression: "details.color"
    }
  })], null, _vm.slotData)], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.prompts.icon && _vm.$dayspan.supports.icon) ? _c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v(_vm._s(_vm.details.icon || 'help'))])], 1), _vm._v(" "), _c('v-list-tile-content', [_vm._t("eventCreatePopoverIcon", [_c('v-select', {
    attrs: {
      "single-line": "",
      "hide-details": "",
      "solo": "",
      "flat": "",
      "full-width": "",
      "items": _vm.$dayspan.icons
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v(_vm._s(item.value))])], 1), _vm._v(" "), _c('v-list-tile-content', [_vm._v("\n                " + _vm._s(item.text) + "\n              ")])]
      }
    }]),
    model: {
      value: (_vm.details.icon),
      callback: function($$v) {
        _vm.$set(_vm.details, "icon", $$v)
      },
      expression: "details.icon"
    }
  })], null, _vm.slotData)], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.prompts.busy && _vm.$dayspan.supports.busy) ? _c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("work")])], 1), _vm._v(" "), _c('v-list-tile-content', [_vm._t("eventCreatePopoverBusy", [_c('v-select', {
    attrs: {
      "single-line": "",
      "hide-details": "",
      "solo": "",
      "flat": "",
      "full-width": "",
      "items": _vm.busyOptions
    },
    model: {
      value: (_vm.details.busy),
      callback: function($$v) {
        _vm.$set(_vm.details, "busy", $$v)
      },
      expression: "details.busy"
    }
  })], null, _vm.slotData)], 2)], 1) : _vm._e()], 1), _vm._v(" "), _vm._t("eventCreatePopoverBodyBottom", null, null, _vm.slotData)], 2), _vm._v(" "), _vm._t("eventCreatePopoverActions", null, null, _vm.slotData)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b314bb5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CalendarEventCreatePopover.vue
// module id = 397
// module chunks = 1